module.exports = __webpack_public_path__ + "static/apple-icon-180x180-9ed408243dcbc93e980b9628af815802.png";